import type { RoomProjection } from "@quizshow/protocol";

export function QuizBoard({
  board,
  onOpen,
  compact = false,
}: {
  board: NonNullable<RoomProjection["board"]>;
  onOpen?: (cellId: string) => void;
  compact?: boolean;
}) {
  return (
    <div className={`quiz-board ${compact ? "quiz-board--compact" : ""}`}>
      {board.categories.map((category) => (
        <section className="quiz-board__category" key={category.categoryId}>
          <h3>{category.name}</h3>
          {category.cells.map((cell) => {
            const content = cell.status === "used" ? "Gespielt" : `${cell.points}`;
            return (
              <button
                className={`quiz-board__cell quiz-board__cell--${cell.status}`}
                disabled={!onOpen || cell.status !== "open"}
                key={cell.cellId}
                onClick={() => onOpen?.(cell.cellId)}
              >
                <span>{content}</span>
                {cell.special === "double" && cell.status !== "open" ? <small>Doppelte Punkte</small> : null}
              </button>
            );
          })}
        </section>
      ))}
    </div>
  );
}
